import React from 'react';

import { connect } from 'react-redux';

import { getToken } from '../../redux/actions/LoginAction';
import { saveHistory } from '../../redux/actions/NavAction';

import { Button, TextField } from '@material-ui/core';
import { Component } from 'react';
import { getVersion } from '../../App';
import { isProdEnv } from '../../env';
import { setError } from '../../redux/actions/MessageAction';
import { baseStyles } from '../../theme/style';
import { urls } from '../../utils/Objects';
import Alerts from '../common/Alerts';
import MyLink from '../common/MyLink';
import { Loading } from '../common';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading:false,
      userName: '',
      pass: '',
      emailError: '',
      passwordError: '',
      error: '',
    };
    this.updateIsLoading = this.updateIsLoading.bind(this);

  }
  componentDidMount() {
  }

  onChange = ({ name, value }) => {
    this.setState({ [name]: value });
    this.props.setError('');
  };
  updateIsLoading = (isLoading) => {
    this.setState({ isLoading });
  };


  onLoginClick = () => {
    const { userName, pass, usertoLogin } = this.state;

    // this.props.getToken(userName, "Leeyahav1234!")
    const loginCredential = { email: userName.trim(), pass:pass.trim() };
      this.props.getToken(loginCredential,this.updateIsLoading);
  };
  render() {
    console.log(this.state);

    return (
      <div style={baseStyles.background}>
        <div style={baseStyles.loginBox}>
          <img src="img/logoGreensunmedLogo@2x.png" alt="Greensun Med Logo" style={baseStyles.logo} />
          <h1 style={baseStyles.title}>Physician Dashboard</h1>
          <div style={baseStyles.form}>
            <TextField
              className="login-field"
              fullWidth={true}
              name="userName"
              error={this.state.emailError.length != 0}
              onChange={(e) => this.onChange(e.target)}
              //   value={""}
              value={this.state.email}
              placeholder="Email Address"
            />
            <div style={{ margin: 5 }} />
            <TextField
              className="login-field"
              fullWidth={true}
              name="pass"
              error={this.state.passwordError.length != 0}
              onChange={(e) => this.onChange(e.target)}
              type="password"
              //   value={"Avik1234!"}
              value={this.state.pass}
              placeholder="Password"
            />
            <div style={baseStyles.link}>
              <MyLink pathname={urls.forgot}>Forgot password?</MyLink>
            </div>

            <Button variant="contained" color="primary" onClick={this.onLoginClick}>
              Log In
            </Button>
            <Alerts />
            <div>
              Don't have an account yet? <MyLink pathname={urls.register}>Get started and register here.</MyLink>
            </div>
            {this.state.isLoading && <Loading />}

          </div>
        </div>
        <div>
          version {getVersion()} {isProdEnv() ? '' : ' - DEV'}
        </div>
      </div>
    );
  }
}
const styles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
};
const mapStateToProps = (state) => {
  return {
    isLogin: state.login.isLogin,
    loginUser: state.login.loginUser,
    error: state.message.error,
  };
};

const mapDispatchToProps = {
  getToken,
  saveHistory,
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
